import SVButton from '@pkgs/shared-client/components/SVButton';
import SVPageHeader from '@pkgs/shared-client/components/SVPageHeader';
import SVPageSubtitle from '@pkgs/shared-client/components/SVPageSubtitle';
import SVPageTitle from '@pkgs/shared-client/components/SVPageTitle';
import { useRouter } from 'next/router';

// TODO: (graphql-after) LOW: Adjust the layout of this page, logo on top, back at home button on 500s, go back button on 404s. Also custom 404/500 page is not working properly

type Props = {
	statusCode: number;
	error?: Error;
};

const SVErrorPage = ({ statusCode, error }: Props) => {
	const router = useRouter();
	const title = statusCode === 404 ? 'Page not found' : 'Hm, something went wrong';

	return (
		<SVPageHeader>
			<SVPageTitle className="block py-14">{title}</SVPageTitle>
			{error && error.message && <SVPageSubtitle>{error.message}</SVPageSubtitle>}
			{router.asPath !== '/' ? (
				<SVButton Component="a" href="/">
					Back to Home
				</SVButton>
			) : null}
		</SVPageHeader>
	);
};

export default SVErrorPage;
